import { render, staticRenderFns } from "./situation.vue?vue&type=template&id=2b01d328&scoped=true&"
import script from "./situation.vue?vue&type=script&lang=js&"
export * from "./situation.vue?vue&type=script&lang=js&"
import style0 from "./situation.vue?vue&type=style&index=0&id=2b01d328&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b01d328",
  null
  
)

export default component.exports